import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../../../constants/common'
import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { useNotification } from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import {
  patchMockViewing,
  VIEWING_STATUS_CHANGE_COPY,
} from '../../../../RentalPortalViewing'
import { useViewingProfileContext } from '../useViewingProfileContext'

import { getIsViewingStatusNoShow } from './useViewingStatusChange.utils'
import { ViewingStatusChangeNote } from './ViewingStatusChangeNote'

export function useViewingStatusChange() {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleCloseModal, handleEntityReload, setModal, viewingData } =
    useViewingProfileContext()

  const [isStatusUpdating, setStatusUpdating] = useState(false)

  const outcomeNoteRef = useRef(EMPTY_STRING)

  function handleOpenStatusConfirmation(status) {
    const copy = VIEWING_STATUS_CHANGE_COPY[status]

    const hasOutcomeNote = getIsViewingStatusNoShow(status)

    outcomeNoteRef.current = EMPTY_STRING

    function handleSubmit() {
      setStatusUpdating(true)

      return patchMockViewing(viewingData?.id, {
        outcome_note: hasOutcomeNote ? outcomeNoteRef.current || null : null,
        status,
      })
        .then(() => {
          handleCloseModal()

          handleAddSuccessNotification(copy.notificationKey)

          return handleEntityReload()
        })
        .catch(() => {
          handleCloseModal()

          handleAddErrorNotification({
            textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
            title: t('RentalPortal.ViewingStatusChangeErrorKey'),
            onClickTextButton: () => handleOpenStatusConfirmation(status),
          })

          return handleEntityReload()
        })
        .finally(() => {
          setStatusUpdating(false)
        })
    }

    setModal(
      <ConfirmationModal
        actionButtonsProps={{ submitText: t(copy.submitKey) }}
        description={t(copy.descriptionKey, {
          applicant: viewingData?.applicant_label,
        })}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={handleSubmit}
      >
        {hasOutcomeNote ? (
          <ViewingStatusChangeNote noteRef={outcomeNoteRef} />
        ) : null}
      </ConfirmationModal>
    )
  }

  return { handleOpenStatusConfirmation, isStatusUpdating }
}
